import { booleanAttribute, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconComponent } from '@reforgium/icon';
import { LangPipe } from '@reforgium/presentia';
import { SkSkeletonComponent } from '@ss/ui';

import { urls } from 'constants/urls.constant';

@Component({
  selector: 'app-tax-legislation-card',
  template: `
    <a
      class="category-card"
      [routerLink]="isSkeleton() ? null : ['/', urls.documentsList]"
      [queryParams]="{ categoryId: id() }"
      [attr.aria-busy]="isSkeleton()"
    >
      @if (isSkeleton()) {
        <sk-skeleton width="75px" height="14px" /><sk-skeleton width="90%" height="18px" />
      } @else {
        <span class="category-badge">{{ 'document.navigation.label' | lang }}</span>
        <h3>{{ name() }}</h3>
        <re-icon class="category-chevron" name="chevron" width="12" height="12" />
      }
    </a>
  `,
  imports: [IconComponent, LangPipe, RouterLink, SkSkeletonComponent],
  styles: `
    :host {
      display: block;
      min-width: 0;
    }
    .category-card {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      box-sizing: border-box;
      height: 100%;
      overflow-wrap: anywhere;
      min-height: 76px;
      padding: 16px;
      border-radius: 16px;
      background: var(--surface-neutral);
      box-shadow: 0 3px 8px #18284405;
      text-decoration: none;
      transition:
        box-shadow 150ms,
        transform 150ms;
    }
    .category-card:hover {
      box-shadow: 0 4px 14px #18284414;
      transform: translateY(-1px);
    }
    .category-card:focus-visible {
      outline: 2px solid #2da5fa;
      outline-offset: 2px;
    }
    h3 {
      margin: 0;
      padding-right: 10px;
      font-size: calc(14px * var(--a11y-font-scale, 1));
      font-weight: 600;
      line-height: 1.4;
      color: var(--text-primary);
    }
    .category-badge {
      border: 1px solid #2da5fa;
      border-radius: 20px;
      padding: 0 5px;
      color: #168de2;
      background: #eaf6ff;
      font-size: calc(10px * var(--a11y-font-scale, 1));
      line-height: 1.4;
    }
    .category-chevron {
      position: absolute;
      top: 16px;
      right: 16px;
      color: var(--text-secondary);
    }
  `,
})
export class TaxLegislationCardComponent {
  name = input<string>();
  id = input<number>();
  isSkeleton = input(false, {
    transform: booleanAttribute,
  });

  protected readonly urls = urls;
}
